export default "__VITE_ASSET__gWMvjUuv__"